import styled from 'styled-components'

export const AccordionList = styled.div`
  > * {
    margin-bottom: 24px;
  }

  .back-link {
    margin-bottom: 20px;
    display: block;
  }

  .copy {
    margin: 20px 0 0;
  }
`
